import React from "react";
import moment from "moment";
import { Tooltip } from "antd";

import calendar from "../assets/calendar.svg";
import { capitalize } from "../scenes/Opportunity/selectors";

import styled from "styled-components/macro";

const Label = styled.div`
  font-size: ${({ fontSize }) => `${fontSize}px`};
  text-align: center;
  line-height: 2;
`;

const Day = styled.div`
  font-size: ${({ fontSize }) => `${fontSize}px`};
  color: ${({ theme, highlighted }) =>
    highlighted ? theme["@primary"] : theme["@gray-50"]};
  text-align: center;
  line-height: 1;
`;

const Month = styled.div`
  font-size: ${({ fontSize }) => `${fontSize}px`};
  color: ${({ theme }) => theme["@gray-80"]};
  text-align: center;
  font-weight: 500;
`;

const Wrapper = styled.div`
  position: relative;
  margin-bottom: 5px;
`;

const Calendar = styled.div`
  display: flex;
  justify-content: center;
`;

const WrapperCalendar = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: ${({ isModal }) => `${isModal ? 18 : 12}px`};
`;

const Date = ({
  value,
  fontSizeLabel,
  fontSizeDay,
  fontSizeMonth,
  label,
  tooltip,
  highlighted,
  isModal = false
}) => {
  const date = moment(value);
  return (
    <Wrapper>
      <Label label fontSize={fontSizeLabel}>
        {label}
      </Label>
      <Calendar>
        <img src={calendar} alt="Calendar" style={{ maxWidth: 60 }} />
        <WrapperCalendar isModal={isModal}>
          <Tooltip placement="top" title={tooltip}>
            <Day fontSize={fontSizeDay} highlighted={highlighted}>
              {date.format("DD")}
            </Day>
            <Month fontSize={fontSizeMonth}>
              {capitalize(date.format("MMM").slice(0, -1))}
            </Month>
          </Tooltip>
        </WrapperCalendar>
      </Calendar>
    </Wrapper>
  );
};

export default Date;
